// init base functions
$(window).on('load', function () {
    classOnBody($('main').attr('id'));
    scrollDirection();
    initGettersAndSetters();
    changeTouchClickText();
});
$(window).on('hashchange', function () {
    initGettersAndSetters(); 
});

// init AOS
if (is.not.ie()) {
    AOS.init();
} else {
    $('*').removeAttr("data-aos");
}

// nav
if ($('.l-nav').length) {
    var propsNav = {
        active: 'is-active',
        scrollInit: 0,
        scrollClassScrolled: 99,
        scrollClassMiddle: 600,
        body: $('body'),
        nav: $('.l-nav'),
        hamburguer: $('.l-nav .c-hamburguer'),
        contentHero: $('.l-nav__contentHero'),
        mask: $('.l-nav__maskMenu'),
        maskAll: $('.l-nav__maskMenu.maskAll'),
    };

    function checkResponsiveMode() {
        var resultCheck;
        var displayCheck = propsNav.hamburguer.css('display');
        if (displayCheck !== 'none') {
            resultCheck = 'is-responsive';
            propsNav.nav.removeClass('is-desktop');
            propsNav.nav.addClass('is-responsive'); 
        } else {
            resultCheck = 'is-desktop';
            propsNav.nav.removeClass('is-responsive');
            propsNav.nav.addClass('is-desktop');
        }
        return resultCheck;
    }

    function closeAllSubMenus() {
        $('.c-subMenu').removeClass('is-active');
    }

    function closeResponsiveMenu() {
        propsNav.hamburguer.removeClass(propsNav.active);
        propsNav.contentHero.removeClass(propsNav.active);
    }

    function hideMaskMenu() {
        propsNav.mask.removeClass(propsNav.active);
    }

    function disableOverflow() {
        propsNav.body.addClass('u-overflowBlocked');
    }

    function enableOverflow() {
        propsNav.body.removeClass('u-overflowBlocked');
    }


    // RESPONSIVE MENU
    // - open / close
    propsNav.hamburguer.on('click', function () {
        if ($(this).hasClass(propsNav.active)) {
            // close menu
            enableOverflow();
            $(this).removeClass(propsNav.active);
            propsNav.maskAll.removeClass(propsNav.active);
            propsNav.contentHero.removeClass(propsNav.active);
        } else {
            // open menu
            disableOverflow();
            $(this).addClass(propsNav.active);
            propsNav.maskAll.addClass(propsNav.active);
            propsNav.contentHero.addClass(propsNav.active);
        }
    });
    // - close
    propsNav.maskAll.on('click', function () {
        closeResponsiveMenu();
        hideMaskMenu();
        closeAllSubMenus();
        enableOverflow();
    });


    // RESPONSIVE MODE
    $(window).on('resize', function () {
        if (checkResponsiveMode() === "is-desktop") {
            if (propsNav.contentHero.hasClass(propsNav.active)) {
                closeAllSubMenus();
                closeResponsiveMenu();
                hideMaskMenu();
            }
        }
    });


    // SCROLL CHANGES
    $(window).on('load', function (event) {
        checkResponsiveMode();
        var scrollBody = $(this).scrollTop();
        if (scrollBody > 1) {
            propsNav.nav.addClass('scrolled');
        } else {
            propsNav.nav.removeClass('scrolled');
        }
    });
    $(window).on('scroll', function () {
        var scrollBody = $(this).scrollTop();
        // scroll up to 99
        if (scrollBody > propsNav.scrollClassScrolled) {
            propsNav.nav.addClass('scrolled');
        } else {
            propsNav.nav.removeClass('scrolled');
        }
        // middle class
        if (scrollBody > propsNav.scrollClassMiddle) {
            propsNav.nav.addClass('hidden');
            propsNav.nav.addClass('scrolledMiddle');
        } else {
            propsNav.nav.removeClass('hidden');
            propsNav.nav.removeClass('scrolledMiddle');
        }
        // scroll up or down
        if (scrollBody < propsNav.scrollInit) {
            propsNav.nav.removeClass('hidden');
            propsNav.nav.addClass('scrolledUp');
            propsNav.nav.removeClass('scrolledDown');
        } else {
            propsNav.nav.removeClass('scrolledUp');
            propsNav.nav.addClass('scrolledDown');
        }
        // close menus on hidden nav
        if (propsNav.nav.hasClass('hidden')) {
            closeAllSubMenus();
            hideMaskMenu();
        }
        // reference var
        propsNav.scrollInit = scrollBody;
    });

}

// modules
if ($('.m_whatsApp').length) {
    var wpp__parts = {
        link_mobile: 'http://api.whatsapp.com/',
        link_web: 'https://web.whatsapp.com/',
        phone: 'send?phone=',
        msg: 'text='
    };
    $('.js-openWhatsModule').on('click', function () {
        var wppNumber = $(this).parent('.m_whatsApp').attr("data-whatsNumber");
        openWhatsApp(wppNumber);
    });

    function openWhatsApp(number) {
        if (is.iphone() || is.androidPhone() || is.windowsPhone() || is.blackberry() || is.mobile()) {
            window.open(wpp__parts.link_mobile + wpp__parts.phone + number, '_blank');
        } else {
            window.open(wpp__parts.link_web + wpp__parts.phone + number, '_blank');
        }
    }
}
if ($('#w_ieDetect').length) {
    function showMessageOnIE(warnLevel) {
        // warnLevel = 1 -> Remover aviso
        // warnLevel = 2 -> Recolher aviso
        // warnLevel = 3 -> Bloquear navegação

        var ieDetectEl = $('#w_ieDetect');
        var ieDetectEl__mask = $('#w_ieDetect__mask');
        var ieDetectEl__unlock = $('.w_ieDetect__unlockSite');

        if (is.ie()) {
            if (warnLevel === 1) {
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__unlock.on('click', function () {
                    ieDetectEl.remove();
                    ieDetectEl__mask.remove();
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if (warnLevel === 2) {
                //block overflow and show modal
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');

                // hide modal and mask
                ieDetectEl__unlock.on('click', function () {
                    $(this).remove();
                    ieDetectEl__mask.remove();
                    ieDetectEl.removeClass('is-visible');
                    ieDetectEl.addClass('is-fixed');
                    $('body').css('overflow-y', 'auto');
                    $('body').css('overflow-x', 'hidden');
                });
            }
            if (warnLevel === 3) {
                $('nav').remove();
                $('header').remove();
                $('footer').remove();
                $('main').remove();
                ieDetectEl__unlock.remove();
                $('body').css('overflow', 'hidden');
                ieDetectEl.removeClass('u-dnone').addClass('is-visible');
                ieDetectEl__mask.removeClass('u-dnone').addClass('is-visible');
            }
        } else {
            ieDetectEl.remove();
            ieDetectEl__mask.remove();
        }
    }

    $(window).on('load', showMessageOnIE(3));
}
if ($('.auxElements__grid').length) {
    $('.auxElements__controls .toggleGrid').on('click', function () {
        $('.auxElements__controls .toggleGrid').toggleClass('is-active');
        $('.auxElements__grid').toggleClass('u-dnone').toggleClass('is-active');
        $('.auxElements__grid .line').toggleClass('is-active');
    });
}
if ($('.auxElements__controls').length) {
    function identifyScroll() {
        returnScroll = 1;
        if ($('body').hasClass('scrolledDown')) {
            returnScroll = 'Down';
        } else if ($('body').hasClass('scrolledUp')) {
            returnScroll = 'Up';
        } else {
            returnScroll = 'Static';
        }
        return returnScroll;
    }

    function tasksAuxVars() {
        $('.auxElements__controls .scrollEfetuado').html(Math.round($(window).scrollTop()));
        $('.auxElements__controls .scrollDirection').html(identifyScroll());
        $('.auxElements__controls .viewportWidth').html(Math.round($(window).width()));
        $('.auxElements__controls .viewportHeight').html(Math.round($(window).height()));
        $('.auxElements__controls .navHeight').html(Math.round(get__navHeight()));
    }

    $(document).on('ready', function () {
        tasksAuxVars();
    });
    $(window).on('load', function () {
        tasksAuxVars();
    });
    $(window).on('resize', function () {
        tasksAuxVars();
    });
    $(window).on('scroll', function () {
        tasksAuxVars();
    });
}

if ($('.s-menuProdutos').length) {
    var swiper__headerHome = new Swiper ('.bannerProduct', { 
        loop: true,
        speed: 400,
        spaceBetween: 0,
        autoHeight: true,
        autoplay: {
            delay: 5000,
        },
        navigation: {
            nextEl: '.btns-slider .swiper-button-next',
            prevEl: '.btns-slider .swiper-button-prev',
        },
    });
}

if ($('.s-produtosHome').length) {
    var swiperProdutosHome = new Swiper(".productsSlider", {
        slidesPerView: 3,
        //spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        on: {
            init: function () {
                var product = $('.productsSlider .swiper-slide-active').attr('data-product');
                var category = $('.productsSlider .swiper-slide-active').attr('data-category');
                $('.textProducts p').html(product);
            },
          },
    });
    swiperProdutosHome.on('slideChangeTransitionEnd', function() {
        var product = $('.productsSlider .swiper-slide-active').attr('data-product');
        var category = $('.productsSlider .swiper-slide-active').attr('data-category');
        $('.textProducts p').html(product);
    });
}

if ($('.s-pratosFav').length) {
    var swiperPratosFav = new Swiper(".swiperPratosFav", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 320px
            600: {
                slidesPerView: 1,
                spaceBetween: 20
            },
            845: {
                slidesPerView: 2,
                spaceBetween: 20
            }
        }
    });
}
;

if ($('.s-menuProdutos').length) {
    var swiperMenuProdutos = new Swiper(".swiperMenuProdutos", {
        slidesPerView: 5,
        spaceBetween: 20,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 320px
            345: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            550: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1000: {
                slidesPerView: 4,
                spaceBetween: 20
            },
        }

    });

    var slideIndex = $('.b-menuProduto.is-active').attr('data-index');
    swiperMenuProdutos.slideTo(slideIndex, 100,false);console.log('index=',slideIndex);
}

if ($('.outrasReceitas').length) {
    var swiperMenuReceitas = new Swiper(".swiperMenuReceitas", {
        slidesPerView: 5,
        spaceBetween: 40,
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            // when window width is >= 320px
            345: {
                slidesPerView: 1,
                spaceBetween: 10
            },
            550: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            1000: {
                slidesPerView: 4,
                spaceBetween: 20
            },
        }

    });
}


if ($('#page__receitas').length) {
    $('.buttonFiltro').on('click', function (e) {
        e.preventDefault();
        $('.filtroOpen').toggleClass('d-none');
        $('.buttonFiltro').toggleClass('is-active');
    });
}

function showProducts(allProducts){
    var src;
    $('.tipoProduto img[data-src]').each(function(){
        src = $(this).attr('data-src');
        $(this).attr('src', src);
    });
    if(allProducts){
        $('.tipoProduto').removeClass('d-none');
    }
    $('.btnSeeMoreProducts').addClass('d-none');
}

$('.btnSeeMoreProducts').on('click', function (e) {
    e.preventDefault();
    showProducts(true);
});

/*$('.b-menuProduto').on('click', function (e) {
    e.preventDefault();
    var tipo = $(this).attr('data-tipo');
    if ($(this).hasClass('is-active')) {
        $('.tipoProduto').removeClass('d-none');
        $('.b-menuProduto').removeClass('is-active');
    } else {
        $('.b-menuProduto').removeClass('is-active');
        $(this).addClass('is-active');
        $('.tipoProduto').addClass('d-none');
        $('.' + tipo).removeClass('d-none');
        showProducts(false);
    }
}); */

$(document).ready(function () {

    $('body').on('click','.buttonTopo', function(){
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });

    $('body').on('change','#formFiltros .field', function(){
        $('#formFiltros').submit();
    });

    if ($('#searchInput').length) {
        var searchVal = $('#searchInput').val();
        if(searchVal !== undefined && searchVal !== null && searchVal !== ''){
            searchKey();
        }
        $('.btnSearchProducts').on('click', function (e) {
            e.preventDefault();
            var option = $(this).attr('data-option');
            $('.b-menuProduto').removeClass('is-active');
            if(option === 'list'){
                searchKey();
            }else{
                $('.formSearchProduto').submit();
            }
        });

        function searchKey() {
            // Declare variables
            var input, filter, ul, li, a, i, txtValue;
            input = document.getElementById('searchInput');
            filter = input.value.toUpperCase();
            ul = document.getElementsByClassName("itens")[0];
            li = ul.getElementsByTagName('li');

            /*var url = location.origin + location.pathname;
            history.pushState({},"",url + '?p=' + input.value);*/

            // Loop through all list items, and hide those who don't match the search query
            for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("div")[0];
                txtValue = a.textContent || a.innerText;

                //console.log(txtValue);
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    li[i].style.display = "";
                    li[i].classList.remove("d-none")
                } else {
                    li[i].style.display = "none";
                    li[i].classList.add("d-none")
                }
            }
        }
    }
    $('.select2_select').select2({
        language: 'pt-BR'
    });

    if($('.formLinks').length){
        $('.formLinks').each(function(){
            var href = $(this).attr('href');
            var site_url  = $('[data-site-url]').attr('data-site-url');
            $(this).attr('href', site_url + href);
        });
    }

    $(document).on('change','.selectEstado',function(){
        var uf = $(this).val();
        var uri = $('[data-site-uri]').attr('data-site-uri');
        $(".selectCidade").html('<option>Carregando cidades...</option>');
        $.ajax({
            type: "POST",
            data: {uf: uf},
            url: uri + "ajax-cidades.php",
            success: function (result) {
                $(".selectCidade").html(result);
            }
        });
    });

    $(document).on('change','#formId_anexo',function(){
        var valor = $(this).val();
        if(valor !== undefined && valor !== '' && valor !== null){
            $('#formId_receita').removeClass('wpcf7-validates-as-required').removeAttr('aria-required');
        }else{
            $('#formId_receita').addClass('wpcf7-validates-as-required').attr('aria-required','true');
        }
    });

    $(document).on('change','#formId_receita',function(){
        var valor = $(this).val();
        if(valor !== undefined && valor !== '' && valor !== null){
            $('#formId_anexo').removeClass('wpcf7-validates-as-required').removeAttr('aria-required');
        }else{
            $('#formId_anexo').addClass('wpcf7-validates-as-required').attr('aria-required','true');
        }
    });

});

function AjustaNewsletter() {
    console.log('Outerheight', $('.b-viverBem .content').outerHeight());
    $( ".s-newsLetter" ).css({
        'margin-top': $(".b-viverBem .content").outerHeight() * -1,
        'padding-top': $(".b-viverBem .content").outerHeight() * 1 + 100
    });
}

$( window ).resize(function() {
    AjustaNewsletter();
});

$(document).ready(function () {
    console.log('Outerheight', $('.b-viverBem .content').outerHeight());

    setTimeout(() => {
        AjustaNewsletter();
      }, "1000")

});